export enum VerificationState {
    Failed = 'failed',
    InProgress = 'in_progress',
    NotStarted = 'not_started',
    Verified = 'verified',
}
